// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"909e81ed","885":"8adee4f8"}[chunkId] + ".chunk.js";
};